import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: "spinner",
	template: `
		<div class="loader" [ngStyle]="{ width: (diameter || 50) + 'px' }">
			<svg class="circular" viewBox="25 25 50 50">
				<circle
					class="path"
					cx="50"
					cy="50"
					fill="none"
					r="20"
					stroke-linecap="round"
					stroke-miterlimit="10"
					stroke-width="4"
					[attr.stroke]="color"
				/>
			</svg>
		</div>
		<ng-content select="p" />
	`,
	styleUrls: ["./spinner.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SpinnerComponent {
	@Input() diameter: number;
	@Input() color: string;
}
